<div class="section-box" fxLayout="column">

  <header class="accent" fxLayout="row" fxLayoutAlign="space-between center">
    <span fxFlex="0 1 auto" class="title">{{"WORKFLOW.SECTIONS" | translate}}</span>

    <button *ngIf="currentStepStatus == 'Pending' && canAddDeleteSections" mat-raised-button 
      fxFlex="0 1 auto" color="primary" class="" (click)="addNewSection()" [disabled]="viewMode">
      {{'WORKFLOW.NEW_SECTION' | translate}} <mat-icon>add</mat-icon>
    </button>
  </header>

  <!--ADD SECTIONS-->
  <form [formGroup]="newSectionForm">
    <ng-container formArrayName="newSections" *ngFor="let newSection of newSections().controls; let i = index">

      <mat-card [formGroupName]="i" class="mt-8 example-card" fxLayout="row wrap">

        <div fxFlex="100%" fxLayout="row" fxLayoutAlign="space-between center" class="mb-12">
          <mat-form-field appearance="outline" fxFlex="1 1 auto">
            <mat-label>{{"WORKFLOW.SECTIONS-TITLE" | translate}} *</mat-label>
            <input class="p-8" matInput formControlName="title" [maxlength]="maxLength" />
          </mat-form-field>

          <button mat-icon-button fxFlex="0 1 auto" color="primary" class="" (click)="removeNewSection(i)">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <mat-form-field appearance="outline" fxFlex="100%" class="mb-12">
          <mat-label>{{'WORKFLOW.SECTIONS-DETAIL' | translate}} *</mat-label>
          <textarea matInput rows="6" formControlName="detail" class="p-8"></textarea>
        </mat-form-field>

        <div fxFlex="100%" fxLayout="row wrap" fxLayoutAlign="space-between center">

          <div class="mb-8" fxFlex="49" fxFlex.lt-sm="100%" fxLayout="row">
            <app-collaborator-suggest fxFlex="100%" formControlName="consultants" [appearance]="'outline'"
              required="false" placeholder="{{'COLAB-SUGGEST.CONSULTANT' | translate}}">
            </app-collaborator-suggest>
          </div>

          <div class="mb-8" fxFlex="49" fxFlex.lt-sm="100%" fxLayout="row">
            <mat-form-field fxFlex="100%" class="alert-fields" appearance="outline">
              <mat-label>{{'COLAB-SUGGEST.CONSULTANT-GROUP' | translate}} *</mat-label>
              <mat-select class="p-12" formControlName="consultantGroups" multiple>
                <mat-option *ngFor="let group of userGroupsConsultants" [value]="group.id">
                  {{group.description}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>

      </mat-card>

    </ng-container>
  </form>

  <!--CONSULTANT SECTIONS-->
  <div *ngFor="let section of sections; let i = index">

    <div class="my-8">

      <mat-card class="example-card">
        <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
          <div fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="flex-start center">

            <button
              *ngIf="!section.readonly && (currentStepStatus == 'SectionReleased' || currentStepStatus == 'Pending') && section.canBeConsultant"
              mat-icon-button
              color="primary" class="mr-12"
              [disabled]="section.readonly"
              (click)="setSectionCompletion(section)">
                <mat-icon 
                  *ngIf="section.completed" 
                  color="accent"
                  matTooltip="{{'WORKFLOW.SECTIONS-UNCOMPLETE' | translate}}">
                    check_circle
                </mat-icon>
                <mat-icon 
                  *ngIf="!section.completed" 
                  color="accent"
                  matTooltip="{{'WORKFLOW.SECTIONS-COMPLETE' | translate}}">
                    radio_button_unchecked
                </mat-icon>
            </button>

            <mat-icon 
              *ngIf="section.completed && (!section.consultants.includes(this.user.userId)) && section.readonly" 
              color="accent" class="mr-28"
              matTooltip="{{'WORKFLOW.SECTIONS-COMPLETED' | translate}}">
                check_circle
            </mat-icon>

            <span [ngClass]="{'ml-52': 
              (!section.completed && section.readonly) || 
              (!section.completed && currentStepStatus != 'SectionReleased')}">
                {{section.title}}
            </span>
          
          </div>
          
          <button *ngIf="currentStepStatus == 'Pending' && canAddDeleteSections" 
            mat-icon-button fxFlex="0 1 auto" 
            color="primary" class=""
            [disabled]="viewMode"
            (click)="removeInitialSection(i)">
            <mat-icon>close</mat-icon>
          </button>
        </mat-card-title>

        <mat-card-subtitle class="pl-52">
          {{section.detail}}
        </mat-card-subtitle>

        <!-- INITIAL LOGS -->
        <ng-container *ngFor="let sectionLog of section.workflowStepInstanceSectionLogs">
          <mat-card-content>
              <span class="font-size-14 text-italic">{{sectionLog.createdBy}} - {{sectionLog.createdDate | date:'yyyy-MM-dd HH:mm'}}</span> 
            
              <div fxLayout="row wrap" fxLayoutAlign="flex-start center" class="mt-8 ml-24 p-8 comment-log">
                <span fxFlex="100%">{{sectionLog.message}}</span>
              </div>

              <div fxLayout="row wrap" fxLayoutAlign="flex-start center" class="mt-8 ml-20">
                <ng-container *ngFor="let file of sectionLog.attachments">
                  <button mat-raised-button color="secondary" class="m-4" (click)="downloadNewsFiles(file.files[0])">
                  <div fxLayout="row" fxLayoutAlign="center center" class="m-4">
                    <mat-icon fxFlex="0 1 auto">get_app</mat-icon><span fxFlex="0 1 200px" class="text-truncate">{{file.files[0].name}}</span>
                  </div>
                </button>
                </ng-container>
              </div>

          </mat-card-content>
          
        </ng-container>

        <!-- NEW LOGS -->
        <div *ngIf="!section.readonly && (currentStepStatus == 'SectionReleased' || currentStepStatus == 'Pending') && section.canBeConsultant" class="p-4" [formGroup]="form">
          <ng-container formArrayName="news">
            <div [formGroupName]="i">

              <mat-form-field appearance="outline" class="my-8" style="width: 100%;">
                <mat-label>{{'ALERTS.COMPLETE_ALERT.BUTTONS.ADD_NEW' | translate}}</mat-label>

                <textarea matInput rows="6" #textarea maxlength="maxLength" formControlName="newsDetail" class="p-8"
                  [readonly]="section.completed"></textarea>

                <div *ngIf="fileUploaders" fxLayout="row wrap">
                    <ng-container *ngFor="let file of fileUploaders?.get(i)?.rawFiles">

                      <button mat-raised-button class="m-8 p-4"
                        (click)="fileUploaders.get(i).removeFile(file)">
                        <div fxLayout="row" fxLayoutAlign="center center">
                          <mat-icon fxFlex="0 1 auto">cancel</mat-icon>
                          <span fxFlex="0 1 200px" class="text-truncate">{{file.name}}</span>
                        </div>
                      </button>

                    </ng-container>
                </div>
              </mat-form-field>

              <div fxLayout="row wrap" fxLayoutAlign="flex-start center" class="">
                <app-simple-file-uploader class="uploader" #fileUploader multiple="true"
                  allowedExtensions=".doc,.DOC,.docx,.DOCX,.xml,.XML,.odt,.ODT,.pdf,.PDF,.rtf,.RTF,.txt,.TXT,.wpd,.WPD,.jpg,.JPG,.png,.PNG,.csv,.CSV,.bmp,.BMP,.svg,.SVG,.tif,.TIF,.tiff,.TIFF,.ods,.ODS,.xls,.XLS,.xlsm,.XLSM,.xlsx,.XLSX,.mp4,.MP4,.mp3,.MP3,.m4a,.M4A,.msg,.MSG,.ogg,.OGG,.opus,.OPUS,.pptx,.PPTX,.eml,.EML,.aac,.AAC,.gif,.GIF,.jpeg,.JPEG">
                  <button mat-raised-button color="accent" [disabled]="loading || section.readonly || section.completed" (click)="uploadFile(i)">
                    {{'ALERTS.COMPLETE_ALERT.BUTTONS.ADD_FILE' | translate}}
                  </button>
                </app-simple-file-uploader>

                <button mat-raised-button color="primary" class="mx-8" (click)="postNews(section, i)"
                  [disabled]="!isNewsDetailValid(i) || section.readonly || section.completed">
                  {{'ALERTS.COMPLETE_ALERT.BUTTONS.ADD' | translate}}
                </button>
              </div>

            </div> <!-- //FormGroupName div-->
          </ng-container>
        </div>

      </mat-card>
    </div>

  </div>
</div>